<template>
	<div>
		<pageHead></pageHead>
		<!-- Swiper  banner -->
		<div class="swiper bannerSwiper">
			<div class="swiper-wrapper">
				<div class="swiper-slide"><img src="../../assets/img/banner/banner.png" /></div>
				<div class="swiper-slide"><img src="../../assets/img/banner/banner2.png" /></div>
			</div>
		</div>

		<div class="introduce">
			<div class="character-wrapper">
				<div class="introduce-top">
					<div class="introduce-img">
						<p>等级保护介绍</p>
						<img src='../../assets/img/introduce.png' />
					</div>
					<div class="introduce-item">
						<p class="title">什么是等级保护？</p>
						<p class="txt">等级保护的核心是对信息系统特别是对业务应用系统安全分等级、按标准进行建设、管理和监督。</p>
					</div>
					<div class="introduce-item">
						<p class="title">为什么要开展等保？</p>
						<p class="txt">通过等级保护工作发现单位信息系统存在的安全隐患和不足，进行安全整改之后，提高信息系统的信息安全防护能力，降低系统被攻击的风险，维护单位良好的形象。</p>
					</div>
					<div class="introduce-item">
						<p class="title">法律法规合规要求</p>
						<p class="txt">等级保护是我国关于信息安全的基本政策，相关政策制度要求单位开展等级保护工作。如《网络安全等级保护管理办法》和《中华人民共和国网络安全法》。</p>
					</div>
				</div>
				<div class="introduce-bottom">
					<p>我国网络安全面临的形势</p>
					<div>
						网络安全是指通过采取必要措施，防范对网络的攻击、侵人、干扰、破坏、非法使用及意外事故，使网络处于稳定可靠运行的状态，以及保障网络数据的完整性、保密性、可用性的能力，维护网络空间主权和国家安全、社会公共利益，保障涉及国家安全、国计民生、社会公共利益的网络的设备设施安全、运行安全、数据安全和信息安全，保护公民、法人和其他组织的合法权益，促进经济社会信息化健康发展。
					</div>
				</div>
			</div>
		</div>

		<div class="service">
			<div class="title">服务内容</div>
			<div class="service-content">
				<div class="service-left">
					<div class="service-item" style="margin-right: 10%;" :class="serviceIndex == 0?'active':''" @click="handleService(0)">等保测评<img src="../../assets/img/icon/Group 1000004812.png"/></div>
					<div class="service-item" style="margin-right: 20%;" :class="serviceIndex == 1?'active':''" @click="handleService(1)">密评咨询<img src="../../assets/img/icon/Group 1000004813.png"/></div>
					<div class="service-item" style="margin-right: 30%;" :class="serviceIndex == 2?'active':''" @click="handleService(2)">软件测试<img src="../../assets/img/icon/Group 1000004814.png"/></div>
					<div class="service-item" style="margin-right: 20%;" :class="serviceIndex == 3?'active':''" @click="handleService(3)">漏洞扫描<img src="../../assets/img/icon/Group 1000004815.png"/></div>
					<div class="service-item" style="margin-right: 10%;" :class="serviceIndex == 4?'active':''" @click="handleService(4)">风险评估<img src="../../assets/img/icon/Group 1000004816.png"/></div>
				</div>
				<div class="service-center">
					<p>{{service[serviceIndex].content}}</p>
					<div class="btn" @click="goTo(service[serviceIndex].path)">了解更多<img src="../../assets/img/icon/arrowR.png" /></div>
				</div>
				<div class="service-right">
					<div class="service-item" style="margin-left: 10%;" :class="serviceIndex == 5?'active':''" @click="handleService(5)"><img src="../../assets/img/icon/Group 1000004817.png"/>安全培训</div>
					<div class="service-item" style="margin-left: 20%;" :class="serviceIndex == 6?'active':''" @click="handleService(6)"><img src="../../assets/img/icon/Group 1000004818.png"/>应急响应</div>
					<div class="service-item" style="margin-left: 30%;" :class="serviceIndex == 7?'active':''" @click="handleService(7)"><img src="../../assets/img/icon/Group 1000004819.png"/>渗透测试</div>
					<div class="service-item" style="margin-left: 20%;" :class="serviceIndex == 8?'active':''" @click="handleService(8)"><img src="../../assets/img/icon/Group 1000004820.png"/>机房检测</div>
					<div class="service-item" style="margin-left: 10%;" :class="serviceIndex == 9?'active':''" @click="handleService(9)"><img src="../../assets/img/icon/Group 1000004821.png"/>代码审计</div>
				</div>
			</div>
		</div>

		<div class="signal content-D">
			<h2>关于我们</h2>
			<div class="signal-wrapper">
				<div class="signal-item signal-left">
					<div>
						<p class="strong-num">2023</p>
						<p class="signal-txt">
							2023年，我司荣获<br />浙江省公安厅“牢筑网络防线，护航亚运安全”网络安全实战攻防演练三等奖<br />杭州市“除险铸盾，护航亚运”网络安全演练二等奖等奖项。</p>
					</div>
					<div>
						<p class="strong-num">100+</p>
						<p class="signal-txt">现有员工100余人</p>
					</div>
				</div>
				<div class="signal-item signal-center">
					<p class="txt">
						浙江青兴科技有限公司2003年成立于温州，公司专注于网络安全等级保护测评业务，为政府、金融、教育、公安、医疗等行业单位提供专业的网络安全等级测评服务。公司不断吸纳综合素质强、专业水平高、经验丰富的优秀专业人才，现有员工100余人。
					</p>
					<p class="txt">公司持续加强在网络安全等级保护测评技术的研究和投入，目前是温州唯一一家获得“网络安全等级测评与检测评估服务认证证书”的机构。</p>
					<div class="btn" @click="goTo('/about')">了解更多<img src="../../assets/img/icon/arrowB.png" /></div>
				</div>
				<div class="signal-item signal-right">
					<div>
						<p class="strong-num">2003</p>
						<p class="signal-txt">浙江青兴科技有限公司2003年成立于温州</p>
					</div>
					<div>
						<p class="strong-num">1</p>
						<p class="signal-txt">目前是温州唯一一家获得“网络安全等级测评与检测评估服务认证证书”的机构</p>
					</div>
				</div>
			</div>
		</div>


		<div class="content-D company-B">
			<h2>荣誉与资质</h2>
			<div class="swiper companySwiper honor-scroll">
				<div class="swiper-wrapper">
					<div class="swiper-slide honor-item">
						<div class="swiper-img">
							<img src="../../assets/img/honor/lwydj.png" />
						</div>
						<p>2023龙湾区“护航亚运”网络安全实战攻防演练第一名</p>
					</div>
					<div class="swiper-slide honor-item">
						<div class="swiper-img">
							<img src="../../assets/img/honor/hzedj.png" />
						</div>
						<p>2023杭州市“除险铸盾，护航亚运”网络安全演练二等奖</p>
					</div>
					<div class="swiper-slide honor-item">
						<div class="swiper-img">
							<img src="../../assets/img/honor/zjsdj.png" />
						</div>
						<p>2023嘉兴市“安网2023”网络安全应急演练二等奖</p>
					</div>
					<div class="swiper-slide honor-item">
						<div class="swiper-img">
							<img src="../../assets/img/honor/sxydj.png" />
						</div>
						<p>2023绍兴市 “护网2023”网络安全实战攻防演练一等奖</p>
					</div>
					<div class="swiper-slide honor-item">
						<div class="swiper-img">
							<img src="../../assets/img/honor/wzydj.png" />
						</div>
						<p>2023温州市“护航亚运”网络安全实战攻防演练一等奖</p>
					</div>
					<div class="swiper-slide honor-item">
						<div class="swiper-img">
							<img src="../../assets/img/honor/zjsdj.png" />
						</div>
						<p>2023浙江省公安厅“牢筑网络防线，护航亚运安全”网络安全实战攻防演练三等奖</p>
					</div>
				</div>
			</div>
			<div class="swiper-pagination"></div>
		</div>

		<page-foot></page-foot>

		<div class="alerts">
			<a href="https://mp.weixin.qq.com/s/c0XWvjPYxbsLNr1YEo851w">浙江警方依法处置三起扰乱公共秩序的网络谣言</a>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import pageHead from '../../components/pageHead'
	import pageFoot from '../../components/pagefoot'
	export default {
		components: {
			pageHead,
			pageFoot
		},
		data() {
			return {
				bannerSwiper: null,
				honorBannerSwiper: null,
				service: [{
						title: "等保测评",
						content: "等保测评的目的是指在以第三方立场，通过 检查、测试、访谈等手段对被测信息系统安全技术、安全管理各个层面的安全控制进行整体性验证，以鉴证信息系统的安全状况， 满足其相对应的安全级别的要求。",
						path: "/equal"
					},
					{
						title: "密评咨询",
						content: "对于新建/改造系统，提供密评政策标准、密码应用解决方案、密码应用建设等咨询服务，直至系统满足密评要求。",
						path: "/confidential"
					},
					{
						title: "软件测试",
						content: "软件检测是在规定的条件下对程序进行操作，以发现程序错误，衡量软件质量，并对其是否能满足设计要求进行评估的过程。对软件形成中的文档、数据以及程序进行的测试，而不仅仅是对程序进行的测试。软件测试贯穿于整个软件生命周期中。",
						path: "/software"
					},
					{
						title: "漏洞扫描",
						content: "漏洞扫描是在用户授权的前提下，通过扫描 等手段对指定的远程或者本地计算机系统的安全脆弱性进行检测，发现可利用漏洞的一种安全检测（渗透攻击）行为。",
						path: "/vulnerability"
					},
					{
						title: "风险评估",
						content: "风险评估技术作为一种风险管理的方法，便是从风险管理角度，依据有关信息安全技术与管理标准，对信息系统及由其处理、传输和储存的信息的机密性、完整性和可用性等 安全属性进行评价的过程。",
						path: "/risk"
					},
					{
						title: "安全培训",
						content: "在服务期间，因发生网络安全事件，客户可以获得网络安全应急响应服务。本公司设有7x24小时的热线电话服务，由专门的客户服务代表受理用户来电，保证用户及时得到技术上的支援。",
						path: "/safety"
					},
					{
						title: "应急响应",
						content: "等保测评的目的是指在以第三方立场，通过 检查、测试、访谈等手段对被测信息系统安全技术、安全管理各个层面的安全控制进行整体性验证，以鉴证信息系统的安全状况，满足其相对应的安全级别的要求。",
						path: "/emergency"
					},
					{
						title: "渗透测试",
						content: "渗透测试是在用户授权的前提下，以模拟黑客攻击的方式，对用户网站的安全漏洞、安全隐患进行全面检测,最终目标是找网站的安全漏洞、评估网站的安全状态、提供漏洞修复建议。",
						path: "/penetration"
					},
					{
						title: "机房检测",
						content: "由于计算机机房环境必须满足计算机等各种微机电子设备和工作人员对温度、湿度、洁净度、电磁场强度、噪音干扰、防漏、电源质量、防雷和接地等条件的要求。所以，一个合格的现代化计算机机房，应该是一个安全可靠、节能高效和有可扩充性的机房。",
						path: "/computer"
					},
					{
						title: "代码审计",
						content: "是依据CVE，以及设备、软件厂商公布的漏洞库，结合专业源代码扫描工具对各种程序语言编写的源代码进行安全审计。能够为客户提供包括安全编码规范咨询、源代码安全现状测评、定位源代码中存在的安全漏洞、分析漏洞风险、给出修改建议等一系列服务",
						path: "/code"
					}
				],
				serviceIndex:0
			}
		},
		mounted() {
			this.setBannerSwiper();
			this.sethonorBannerSwiper();
		},
		methods: {
			setBannerSwiper() {
				this.bannerSwiper = new Swiper(".bannerSwiper", {
					autoplay: {
						delay: 3000,
						disableOnInteraction: false
					},
					loop: true,
					observer: true,
					observeParents: true,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
				});
			},
			sethonorBannerSwiper() {
				this.honorBannerSwiper = new Swiper(".companySwiper", {
					slidesPerView: 4,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
				});
			},
			goTo(path) {
				this.$router.push({
					path: path
				})
			},
			handleService(val){
				this.serviceIndex = val
			}
		}
	}
</script>

<style>
	.alerts{
		line-height: 24px;
    	width: 240px;
		padding: 10px;
		position: fixed;
		bottom: 30px;
		right: 30px;
		background: #ebe9e9;
		cursor: pointer;
		border-radius: 5px;
		box-shadow: 0px 3px 10px 0px #cdcdcd;
	}

	.alerts a{
		color: red;
	}

	.swiper {
		overflow: hidden;
	}

	.bannerSwiper {
		width: 100%;
		height: 100%;
		margin-top: 80px;
	}

	.swiper-slide {
		text-align: center;
		background: #fff;
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
	}

	.swiper-slide img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.swiper-button-next,
	.swiper-button-prev {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		border: 1px solid #ccc;
		width: 45px;
		height: 45px;
	}

	.swiper-button-next:hover,
	.swiper-button-prev:hover {
		background-color: #0e538a;
		border: 1px solid #0e538a;
	}

	.swiper-pagination {
		position: absolute;
		bottom: 120px;
		width: 30%;
		left: 50%;
		transform: translateX(-50%);
	}

	.swiper-container-horizontal>.swiper-pagination-bullets {
		bottom: -10px;
	}

	.swiper-pagination-bullet {
		border-radius: 0;
		width: 20px;
		margin: 0 10px;
	}

	.introduce {
		width: 100%;
		height: 650px;
	}

	.introduce-top {
		width: 1000px;
		height: 320px;
		padding: 20px 20px 40px;
		transform: translateY(-40px);
		margin: 0 auto;
		background-color: #fff;
		z-index: 99;
		position: relative;
		box-shadow: 0px 0px 10px 0px #c5c2c2;
		display: flex;
		justify-content: space-around;
	}

	.introduce-img {
		width: 200px;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.introduce-img p {
		font-size: 32px;
		font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
		font-weight: 500;
		color: #0D2750;
		line-height: 48px;
	}

	.introduce-item {
		width: 220px;
		height: 200px;
		background-color: #EEF3FF;
		padding: 20px 16px 0;
		align-self: flex-end;
	}

	.introduce-item .title {
		font-size: 20px;
		font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
		font-weight: 400;
		color: #0D2750;
		line-height: 38px;
	}

	.introduce-item .txt {
		font-size: 14px;
		font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
		font-weight: 400;
		color: #6D81A0;
		line-height: 20px;
	}

	.character-wrapper {
		position: relative;
		margin: 0 auto;
		max-width: 1200px;
		height: 600px;
	}

	.introduce-bottom {
		position: absolute;
		bottom: 80px;
	}

	.introduce-bottom>p {
		text-align: center;
		height: 48px;
		font-size: 32px;
		font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
		font-weight: 500;
		margin-bottom: 24px;
	}

	.introduce-bottom>div {
		width: 1200px;
		height: 90px;
		font-size: 20px;
		font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
		font-weight: 400;
		color: #6D81A0;
		line-height: 30px;
	}

	.sbgd-icon {
		margin: 5% auto 30px;
		width: 100%;
		max-width: 185px;
		min-width: 0px;
		height: auto;
		min-height: 0px;
	}

	.content-D {
		text-align: center;
		margin: 0 auto;
		font-size: 14px;
		padding: 0 20px;
	}

	/* 服务内容 */
	.service {
		width: 100%;
		height: 1000px;
		background: url('../../assets/img/icon/servicebg.png') no-repeat center center;
		background-size: cover;
		padding-top: 80px;
		position: relative;
	}

	.service .title {
		width: 176px;
		height: 64px;
		background: url('../../assets/img/icon/serviceT.png') no-repeat center center;
		background-size: 100% 100%;
		font-size: 32px;
		font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 62px;
		text-align: center;
		margin: 0 auto 80px;
	}

	.service-center {
		width: 536px;
		height: 536px;
		position: absolute;
		top: 52.5%;
		left: 50.2%;
		transform: translate(-50%, -50%);
		background: url('../../assets/img/icon/Ellipse.png') no-repeat center center;
		background-size: 100% 100%;
		padding: 140px 100px 0;
	}

	.service-center p {
		font-size: 20px;
		font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 30px;
	}

	.service-center .btn {
		text-align: left;
		color: #FFFFFF;
		font-size: 20px;
	}

	.service-left,
	.service-right {
		position: absolute;
		width: 300px;
		height: 536px;
		top: 52.5%;
		transform: translate(-50%,-50%);
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	
	.service-left>div,
	.service-right>div{
		width: 176px;
		height: 64px;
		background: url('../../assets/img/icon/serviceT.png') no-repeat center center;
		background-size: 100% 100%;
		font-size: 20px;
		font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 62px;
		text-align: center;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		cursor: pointer;
	}
	
	.service-left>div.active,
	.service-right>div.active {
		background: url('../../assets/img/icon/Rectangle 406.png') no-repeat center center;
		background-size: 100% 100%;
	}

	.service-left {
		left: calc(55% - 536px);
	}
	
	.service-left>div{
		margin-left: auto;
	}

	.service-right {
		left: calc(46% + 536px);
	}
	
	.service-right>div{
		margin-right: auto;
	}
	
	.service-item img{
		width: 32px;
		height: 32px;
	}

	.content-D h2 {
		font-size: 32px;
		color: #0D2750;
		line-height: 48px;
		margin-bottom: 40px;
	}

	.signal {
		background: url('../../assets/img/about.png') no-repeat center center;
		background-size: cover;
		width: 100%;
		height: 700px;
		padding: 138px 0 180px;
	}

	.signal-wrapper {
		display: flex;
		justify-content: space-around;
	}

	.signal-left {
		text-align: right;
		width: 30% !important;
	}

	.signal-center {
		text-align: left;
		width: 24% !important;
		font-size: 20px;
		font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
		font-weight: 400;
		color: #6D81A0;
		line-height: 30px;
	}

	.signal-right {
		width: 30% !important;
		text-align: left;
	}

	.strong-num {
		font-size: 24px;
		font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
		font-weight: 500;
		color: #0D2750;
		display: inline-block;
		border-bottom: 1px solid #0D2750;
		margin-bottom: 8px;
	}

	.signal-txt {
		font-size: 16px;
		font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
		font-weight: 400;
		color: #6D81A0;
		line-height: 24px;
	}

	.signal-left,
	.signal-right {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.bulge {
		display: flex;
		margin: 0 auto;
		width: 100%;
		max-width: 1400px;
		justify-content: space-around;
		align-items: center;
		height: 70px;
		margin-top: 40px;
	}

	.bulge span {
		font-size: 50px;
		display: inline-block;
		margin-bottom: 5px;
		margin-right: 5px;
	}

	.buldge-line {
		width: 2px;
		height: 60px;
		background-color: #fff;
	}

	.honor-scroll {
		width: 100%;
		max-width: 1200px;
		overflow: hidden;
		font-size: 14px;
		margin: 0 auto;
		position: relative;
	}

	.honor-item {
		width: 260px;
		display: flex;
		flex-direction: column;
		text-align: center;
	}

	.swiper-img {
		width: 100%;
		/* height: 267px; */
		margin-bottom: 16px;
	}

	.swiper-img>img {
		width: 100%;
		height: 100%;
	}

	.btn {
		margin: 20px auto 0;
		cursor: pointer;
		font-size: 20px;
		font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
		font-weight: 400;
		color: #006AFF;
		line-height: 30px;
		vertical-align: middle;
		text-align: center;
	}

	.company-B {
		background-size: 100%;
		height: 620px;
		padding: 80px 260px;
		position: relative;
	}

	@media screen and (max-width: 685px) {}

	@keyframes scroll {
		0% {
			transform: translateX(0%);
		}

		100% {
			transform: translateX(-2400px);
		}
	}

	@keyframes scrollY {
		100% {
			transform: translateY(0);
		}
	}
</style>